import type { ReactElement } from 'react';
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Login from "../pages/login/page";
import Dashboard from "../pages/dashboard/page";
import TodayPage from "../pages/today/page";
import AttentionPage from "../pages/attention/page";
import LeadsPage from "../pages/leads/page";
import ClientsPage from "../pages/clients/page";
import CasesPage from "../pages/cases/page";
import ProductsPage from "../pages/products/page";
import FeesPage from "../pages/fees/page";
import TemplatesPage from "../pages/templates/page";
import TasksPage from "../pages/tasks/page";
import FinancePage from "../pages/finance/page";
import CalculatorsPage from "../pages/calculators/page";
import CalendarPage from "../pages/calendar/page";
import PublicationsPage from "../pages/publications/page";
import MessagesPage from "../pages/messages/page";
import AIPage from "../pages/ai/page";
import KnowledgePage from "../pages/knowledge/page";
import ReportsPage from "../pages/reports/page";
import ImportExportPage from "../pages/import-export/page";
import BackupPage from "../pages/backup/page";
import DeadlinesPage from "../pages/deadlines/page";
import ChecklistsPage from "../pages/checklists/page";
import SitesPage from "../pages/sites/page";
import SettingsPage from "../pages/settings/page";
import IntegrationsPage from "../pages/integrations/page";
import PortalPage from "../pages/portal/page";
import DocumentsPage from "../pages/documents/page";
import RequireAuth from "@/components/feature/RequireAuth";
import RequireRole from "@/components/feature/RequireRole";
import UsersPage from "../pages/users/page";

const protectedRoute = (element: ReactElement) => <RequireAuth>{element}</RequireAuth>;

const routes: RouteObject[] = [
  { path: "/", element: <Login /> },
  { path: "/login", element: <Login /> },
  { path: "/dashboard", element: protectedRoute(<Dashboard />) },
  { path: "/today", element: protectedRoute(<TodayPage />) },
  { path: "/attention", element: protectedRoute(<AttentionPage />) },
  { path: "/leads", element: protectedRoute(<LeadsPage />) },
  { path: "/clients", element: protectedRoute(<ClientsPage />) },
  { path: "/cases", element: protectedRoute(<CasesPage />) },
  { path: "/products", element: protectedRoute(<ProductsPage />) },
  { path: "/fees", element: protectedRoute(<FeesPage />) },
  { path: "/documents", element: protectedRoute(<DocumentsPage />) },
  { path: "/templates", element: protectedRoute(<TemplatesPage />) },
  { path: "/tasks", element: protectedRoute(<TasksPage />) },
  { path: "/finance", element: protectedRoute(<FinancePage />) },
  { path: "/calculators", element: protectedRoute(<CalculatorsPage />) },
  { path: "/calendar", element: protectedRoute(<CalendarPage />) },
  { path: "/agenda", element: protectedRoute(<CalendarPage />) },
  { path: "/publications", element: protectedRoute(<PublicationsPage />) },
  { path: "/messages", element: protectedRoute(<MessagesPage />) },
  { path: "/ai", element: protectedRoute(<AIPage />) },
  { path: "/knowledge", element: protectedRoute(<KnowledgePage />) },
  { path: "/library", element: protectedRoute(<KnowledgePage />) },
  { path: "/reports", element: protectedRoute(<ReportsPage />) },
  { path: "/relatorios", element: protectedRoute(<ReportsPage />) },
  {
    path: "/import-export",
    element: protectedRoute(
      <RequireRole roles={['admin', 'lawyer']}>
        <ImportExportPage />
      </RequireRole>
    ),
  },
  {
    path: "/backup",
    element: protectedRoute(
      <RequireRole roles={['admin']}>
        <BackupPage />
      </RequireRole>
    ),
  },
  { path: "/deadlines", element: protectedRoute(<DeadlinesPage />) },
  { path: "/prazos", element: protectedRoute(<DeadlinesPage />) },
  { path: "/checklists", element: protectedRoute(<ChecklistsPage />) },
  { path: "/controladoria", element: protectedRoute(<ChecklistsPage />) },
  { path: "/sites", element: protectedRoute(<SitesPage />) },
  { path: "/links", element: protectedRoute(<SitesPage />) },
  {
    path: "/settings",
    element: protectedRoute(
      <RequireRole roles={['admin']}>
        <SettingsPage />
      </RequireRole>
    ),
  },
  {
    path: "/users",
    element: protectedRoute(
      <RequireRole roles={['admin']}>
        <UsersPage />
      </RequireRole>
    ),
  },
  {
    path: "/configuracoes",
    element: protectedRoute(
      <RequireRole roles={['admin']}>
        <SettingsPage />
      </RequireRole>
    ),
  },
  {
    path: "/integrations",
    element: protectedRoute(
      <RequireRole roles={['admin']}>
        <IntegrationsPage />
      </RequireRole>
    ),
  },

  { path: "/portal", element: protectedRoute(<PortalPage />) },
  { path: "*", element: <NotFound /> },
];

export default routes;
